import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

export interface AppConfig {
  dbName: string;
}

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  private config: AppConfig = {
    dbName: environment.dbName, // fallback to build-time value
  };

  constructor() {
    // Check if config was preloaded before bootstrap
    const preloaded = (window as any).__APP_CONFIG__;
    if (preloaded?.dbName) {
      this.config.dbName = preloaded.dbName;
    }
  }

  async loadConfig(): Promise<void> {
    try {
      const response = await fetch('/assets/config.json');
      if (response.ok) {
        const runtimeConfig = await response.json();
        if (runtimeConfig.dbName) {
          this.config.dbName = runtimeConfig.dbName;
        }
      }
    } catch {
      console.warn('Could not load runtime config, using build-time defaults');
    }
  }

  get dbName(): string {
    return this.config.dbName;
  }
}
